import { Imprint, theme } from 'ComponentLibrary'
import { ThemeProvider } from '@mui/material'
import { useEffect } from 'react'
import { getPublicLegalPageLocale } from 'ClientPortal/src/pages/Privacy/legalPageLocale'

export const ImprintPage = () => {
    const locale = getPublicLegalPageLocale()

    useEffect(() => {
        document.documentElement.lang = locale
    }, [locale])

    return (
        <ThemeProvider theme={theme}>
            <Imprint isImprintOpen={true} locale={locale} />
        </ThemeProvider>
    )
}
